export default __webpack_public_path__ + "static/home-slide002-037d171dd0b7e8438460c9ca4946ff24.jpg";